import { render, staticRenderFns } from "./PopupAddPackage.vue?vue&type=template&id=6eff54e8&"
import script from "./PopupAddPackage.vue?vue&type=script&lang=js&"
export * from "./PopupAddPackage.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddPackage.vue?vue&type=style&index=0&id=6eff54e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports